"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CodeblockLayout = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const context_1 = require("../../styles/context");
const blockClass = (0, nano_theme_1.drule)({
    ...nano_theme_1.lightTheme.font.mono.mid,
    d: 'block',
    bdrad: '5px',
    trs: 'background 0.6s ease 0s',
    fz: '.9em',
    lh: 1.3,
    bd: '1px solid transparent',
    pad: '8px',
    mar: 0,
    ovx: 'auto',
    '@media (max-width: 800px)': {
        pd: '4px',
    },
});
const blockCompactClass = (0, nano_theme_1.rule)({
    pad: `${nano_theme_1.lightTheme.g(0.2)}px ${nano_theme_1.lightTheme.g(0.3)}px !important`,
});
const CodeblockLayout = ({ compact, children, ...rest }) => {
    const styles = (0, context_1.useStyles)();
    const cls = blockClass({
        col: styles.g(0.3),
        bg: styles.g(0, 0.02),
        '&:hover': {
            bg: styles.bg + '',
            bd: `1px solid ${styles.g(0, 0.16)}`,
        },
    });
    return (React.createElement("div", { ...rest, className: cls + (compact ? ' ' + blockCompactClass : '') }, children));
};
exports.CodeblockLayout = CodeblockLayout;
